import { render } from "./considerations.vue?vue&type=template&id=cfedcb8a&scoped=true"
import script from "./considerations.vue?vue&type=script&lang=js"
export * from "./considerations.vue?vue&type=script&lang=js"

import "./considerations.vue?vue&type=style&index=0&id=cfedcb8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cfedcb8a"

export default script